import Layout from '@/layout/base/layoutSegfy'

export default [{
    path: '/LGPD/politica',
    component: Layout,
    children: [
        {
            path: '',
            component: () => import('@/components/LGPD/politica'),
            meta: {
                auth: true
            } 
        }
    ]
}]
